import * as Immutable from "immutable";
import { useQuery } from "@tanstack/react-query";
import AuthenticationBackend from "logic/authentication/AuthenticationBackend";
import { qualifyUrl } from "util/URLUtils";
import fetch, { Builder } from "logic/rest/FetchProvider";
import PaginationURL from "util/PaginationURL";
import ApiRoutes from "routing/ApiRoutes";
import UserOverview from "logic/users/UserOverview";
export const AUTHENTICATION_QUERY_KEY = ["authentication"];
export const createAuthBackend = (authBackend) => {
  const url = qualifyUrl(ApiRoutes.AuthenticationController.create().url);
  return fetch("POST", url, authBackend).then(
    (result) => result ? {
      backend: AuthenticationBackend.fromJSON(result.backend)
    } : null
  );
};
export const loadAuthBackend = (backendId) => {
  const url = qualifyUrl(ApiRoutes.AuthenticationController.load(encodeURIComponent(backendId)).url);
  return fetch("GET", url).then(
    (result) => result ? {
      backend: AuthenticationBackend.fromJSON(result.backend)
    } : null
  );
};
export const loadActiveAuthBackend = () => {
  const url = qualifyUrl(ApiRoutes.AuthenticationController.loadActive().url);
  return fetch("GET", url).then(
    (result) => result ? {
      backend: result.backend ? AuthenticationBackend.fromJSON(result.backend) : null,
      context: { backendsTotal: result.context.backends_total }
    } : null
  );
};
export const updateAuthBackend = (backendId, payload) => {
  const url = qualifyUrl(ApiRoutes.AuthenticationController.update(backendId).url);
  return fetch("PUT", url, payload).then(
    (result) => result ? {
      backend: AuthenticationBackend.fromJSON(result.backend)
    } : null
  );
};
export const deleteAuthBackend = (backendId) => {
  const url = qualifyUrl(ApiRoutes.AuthenticationController.delete(backendId).url);
  return fetch("DELETE", url);
};
export const testAuthConnection = (payload) => {
  const url = qualifyUrl(ApiRoutes.AuthenticationController.testConnection().url);
  return fetch("POST", url, payload);
};
export const testAuthLogin = (payload) => {
  const url = qualifyUrl(ApiRoutes.AuthenticationController.testLogin().url);
  return fetch("POST", url, payload);
};
export const setActiveAuthBackend = (backendId) => {
  const url = qualifyUrl(ApiRoutes.AuthenticationController.updateConfiguration().url);
  return fetch("POST", url, { active_backend: backendId });
};
export const loadAuthBackendsPaginated = ({ page, perPage, query }) => {
  const url = PaginationURL(ApiRoutes.AuthenticationController.servicesPaginated().url, page, perPage, query);
  return fetch("GET", qualifyUrl(url)).then((response) => ({
    context: {
      activeBackend: response.context.active_backend
    },
    list: Immutable.List(
      response.backends.map((backend) => AuthenticationBackend.fromJSON(backend))
    ),
    pagination: {
      page: response.page,
      perPage: response.per_page,
      query: response.query,
      count: response.count,
      total: response.total
    }
  }));
};
export const loadAuthBackendUsersPaginated = (authBackendId, { page, perPage, query }) => {
  const url = PaginationURL(
    ApiRoutes.AuthenticationController.loadUsersPaginated(authBackendId).url,
    page,
    perPage,
    query
  );
  return fetch("GET", qualifyUrl(url)).then(
    (response) => ({
      list: Immutable.List(response.users.map((user) => UserOverview.fromJSON(user))),
      pagination: {
        page: response.page,
        perPage: response.per_page,
        query: response.query,
        count: response.count,
        total: response.total
      },
      adminUser: void 0
    })
  );
};
export const loadActiveAuthBackendType = () => {
  const url = qualifyUrl(ApiRoutes.AuthenticationController.loadActiveBackendType().url);
  return new Builder("GET", url).build().then((response) => response.json()).then((result) => result.backend);
};
export const useActiveAuthBackend = () => useQuery({
  queryKey: [...AUTHENTICATION_QUERY_KEY, "active"],
  queryFn: loadActiveAuthBackend
});
